// repoActionMatrix.js

export const ACTIONS = {
  CHAT: "chat",
  DOWNLOAD: "download",
  MOVE: "move",
  DELETE: "delete",
  RENAME: "rename",
  CHANGE_STATUS: "changeStatus",
  TRAIN_FILE: "trainFile",
  RESTORE_FILE: "restoreFile",

  // Admin Only
  APPROVE: "approve",
  PENDING: "pending",
  REJECTED: "rejected",
};

export const REPO_ACTION_MATRIX = {
  // ============================================================
  // USER
  // ============================================================
  user: {
    // ==========================
    // PERSONAL REPOSITORY
    // ==========================
    personal: {
      approved: {
        menu: [
          ACTIONS.CHAT,
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.CHAT,
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
        ],
      },

      duplicate: {
        menu: [
          ACTIONS.CHAT,
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.CHAT,
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
      },

      folder: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
      },
    },

    // ==========================
    // GLOBAL REPOSITORY
    // ==========================
    global: {
      approved: {
        menu: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
        floating: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
      },

      pending: {
        menu: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
        floating: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
      },

      duplicate: {
        menu: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
        floating: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
      },

      rejected: {
        menu: [ACTIONS.DOWNLOAD],
        floating: [ACTIONS.DOWNLOAD],
      },

      folder: {
        menu: [ACTIONS.DOWNLOAD],
        floating: [ACTIONS.DOWNLOAD],
      },
    },

    // ==========================
    // GROUP REPOSITORY
    // ==========================
    group: {
      approved: {
        menu: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
        floating: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
      },

      pending: {
        menu: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
        floating: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
      },

      duplicate: {
        menu: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
        floating: [ACTIONS.CHAT, ACTIONS.DOWNLOAD],
      },

      rejected: {
        menu: [ACTIONS.DOWNLOAD],
        floating: [ACTIONS.DOWNLOAD],
      },

      folder: {
        menu: [ACTIONS.DOWNLOAD],
        floating: [ACTIONS.DOWNLOAD],
      },
    },

    // ==========================
    // MY DRIVE
    // ==========================
    myDrive: {
      saved: {
        menu: [
          ACTIONS.TRAIN_FILE,
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
      },

      deleted: {
        menu: [
          ACTIONS.RESTORE_FILE,
          ACTIONS.DOWNLOAD,
          ACTIONS.DELETE,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.RESTORE_FILE,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
        ],
      },

      folder: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
      },
    },
  },

  // ============================================================
  // ADMIN
  // ============================================================
  admin: {
    // ==========================
    // GLOBAL REPOSITORY
    // ==========================
    global: {
      approved: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
          ACTIONS.APPROVE,
          ACTIONS.PENDING,
          ACTIONS.REJECTED,
        ],
      },

      pending: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
          ACTIONS.APPROVE,
          ACTIONS.PENDING,
          ACTIONS.REJECTED,
        ],
      },

      duplicate: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
          ACTIONS.APPROVE,
          ACTIONS.PENDING,
          ACTIONS.REJECTED,
        ],
      },

      rejected: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
          ACTIONS.APPROVE,
          ACTIONS.PENDING,
          ACTIONS.REJECTED,
        ],
      },

      folder: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
      },
    },

    // ==========================
    // GROUP REPOSITORY
    // ==========================
    group: {
      approved: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
          ACTIONS.APPROVE,
          ACTIONS.PENDING,
          ACTIONS.REJECTED,
        ],
      },

      pending: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
          ACTIONS.APPROVE,
          ACTIONS.PENDING,
          ACTIONS.REJECTED,
        ],
      },

      duplicate: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
          ACTIONS.APPROVE,
          ACTIONS.PENDING,
          ACTIONS.REJECTED,
        ],
      },

      rejected: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.CHANGE_STATUS,
          ACTIONS.RENAME,
          ACTIONS.APPROVE,
          ACTIONS.PENDING,
          ACTIONS.REJECTED,
        ],
      },

      folder: {
        menu: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
        floating: [
          ACTIONS.DOWNLOAD,
          ACTIONS.MOVE,
          ACTIONS.DELETE,
          ACTIONS.RENAME,
        ],
      },
    },
  },
};